var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTimelinePin = function SvgTimelinePin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 91,
    viewBox: "0 0 22 91",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.68701C15.9706 2.68701 20 6.71645 20 11.687C20 16.6576 15.9706 20.687 11 20.687C6.02944 20.687 2 16.6576 2 11.687C2 6.71645 6.02944 2.68701 11 2.68701ZM22 11.687C22 5.61188 17.0751 0.687012 11 0.687012C4.92487 0.687012 0 5.61188 0 11.687C0 17.7621 4.92487 22.687 11 22.687C17.0751 22.687 22 17.7621 22 11.687Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.68701C10.4477 4.68701 10 5.13473 10 5.68701V11.069L6.55279 12.7926C6.05881 13.0396 5.85858 13.6402 6.10557 14.1342C6.35256 14.6282 6.95324 14.8284 7.44721 14.5814L11.4472 12.5814C11.786 12.412 12 12.0658 12 11.687V5.68701C12 5.13473 11.5523 4.68701 11 4.68701Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 91L10.5 22H11.5L11.5 91H10.5Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimelinePin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timeline-pin.8b72eb03.svg";
export { ForwardRef as ReactComponent };